import OmniApiClient from "./base";

// Google API
export const googleApi = {
  // Create new credential and start OAuth flow
  startGoogleAuth: (scopes = "", displayName = "") => {
    return OmniApiClient.post("/google/auth/start", {
      scopes: scopes,
      display_name: displayName,
    });
  },

  // Upload Google credentials JSON and start OAuth flow (legacy)
  uploadCredentialsAndAuth: (jsonFile, scopes = null) => {
    const formData = new FormData();
    formData.append("json_file", jsonFile);

    if (scopes && scopes.length > 0) {
      scopes.forEach((scope) => {
        formData.append("scopes", scope);
      });
    }

    return OmniApiClient.post("/google/auth", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // Handle OAuth callback
  handleOAuthCallback: (code, state) => {
    return OmniApiClient.get(
      `/google/oauth/callback?code=${code}&state=${state}`,
    );
  },

  // Get all stored Google credentials
  getCredentials: () => {
    return OmniApiClient.get("/google/credentials/");
  },

  // Delete a specific credential by ID
  deleteCredential: (credentialId) => {
    return OmniApiClient.delete(`/google/credentials/${credentialId}`);
  },

  // Test a credential by making a test API call
  testCredential: (credentialId) => {
    return OmniApiClient.post(`/google/credentials/${credentialId}/test`);
  },

  // Reauthorize a credential
  reauthorizeCredential: (credentialId) => {
    return OmniApiClient.post(
      `/google/credentials/${credentialId}/reauthorize`,
    );
  },

  // Refresh token for a credential
  refreshCredential: (credentialId) => {
    return OmniApiClient.post(`/google/credentials/${credentialId}/refresh`);
  },

  // Toggle active status for a credential (only one can be active at a time)
  toggleActiveCredential: (credentialId) => {
    return OmniApiClient.post(
      `/google/credentials/${credentialId}/toggle-active`,
    );
  },
};
